<app-upload-files
  [title]="'Test title'"
  [formControls]="formControls"
  [canAdd]="true"
  (createNewFileGroup)="createNewFileGroup()"
  (fileRemoved)="fileRemoved($event)"
></app-upload-files>

<app-validated-checkbox
  [inputFormControl]="checboxData"
  [inputFormControlName]="'checboxData'"
  [label]="'Test label'"
></app-validated-checkbox>
<app-validated-checkbox
  [inputFormControl]="checboxData2"
  [inputFormControlName]="'checboxData2'"
  [label]="'Test label 2'"
></app-validated-checkbox>
<app-validated-input
  [inputFormControl]="inputData"
  inputFormControlName="inputData"
  label="inputData"
></app-validated-input>
<app-validated-currency-input
  [inputFormControl]="currencyInput"
  [currencyCode]="'HUF'"
  inputFormControlName="inputData"
  label="inputData"
></app-validated-currency-input>
<button (click)="validate()">Validate</button>
<div class="mt-4">
  <h3>Galéria</h3>
  <div class="gallery-demo">
    <h4>By default 5 image displayed / row</h4>
    <app-img-gallery [images]="images" />
  </div>
  <hr />
  <div class="gallery-demo">
    <h4>Can set the image / row</h4>
    <app-img-gallery [perRow]="3" [images]="images" />
  </div>
  <hr />
  <div class="gallery-demo">
    <h4>
      Can set "maxToDisplayAmount" for example here the images count is
      {{ manyImage.length }}
    </h4>
    <h4>the + tile emits a boolean output for now</h4>
    <app-img-gallery [maxToDisplayAmount]="8" [images]="manyImage" />
  </div>
  <hr />
  <div class="gallery-demo">
    <h4>If the image is not found there is a placeholder for that</h4>
    <app-img-gallery [images]="imagesWithNotFoundId" />
  </div>
</div>
<app-validated-text-editor
  label="Test text editor"
  inputFormControlName="textEditor"
  [inputFormControl]="textEditor"
></app-validated-text-editor>

<div *ngFor="let gallery of galleries; index as i" class="container">
  <h3 class="title">Gallery1-{{ i + 1 }}</h3>
  <div class="gallery">
    <a
      *ngFor="let image of gallery"
      class="glightbox"
      [href]="image"
      [attr.data-gallery]="'gallery' + (i + 1)"
    >
      <img class="image" [src]="image" alt="" />
    </a>
  </div>
</div>
